import React from 'react';
import { useOnClickOutside } from '../../hooks/useOnClickOutside';
import TextField from '../input/text';
import './style.scss';

const getColors = () =>  [
    "#F2C700", "#F49D00", "#F05126", "#C33821", "#C2185B",
    "#FF4081", "#B946FC", "#913DB6", "#468CFE", "#336DCF",
    "#336DCE", "#2C9AB7", "#00BD9C", "#019F82", "#192D4E"
];

const ColorPicker = ({
    style={},
    iconStyle = {},
    color=null,
    changeColor = null,
    colorStyle = {},
    inputProps = {},
    children = null
}) => {

    const [open, setOpen] = React.useState(false);
    const [text, setText] = React.useState('');
    const colors = getColors();
    const openPoup = (e) => {
        console.log(e.target.getBoundingClientRect());
        setOpen(true);
    }
    const onColorPicker = (color) => {
        if (changeColor) {
            setOpen(false);
            changeColor(color);
        }
    }
    const [refColorPicker] = useOnClickOutside(() => {
        setText('');
        setOpen(false);
    });

    const onEnterValue = (e) => {
        setText(e.target.value);
        var hexValue = e.target.value.trim();
        if(e.keyCode == 13){
            setText('');
            setOpen(false);
            if(hexValue && hexValue.match(/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/) !== null){
                changeColor(hexValue);
            }
        }
    }

    let _iconStyle = {...iconStyle, backgroundColor: color};
    if (children) {
        _iconStyle = {};
    }
    return (
        <div className='color-picker-wrapper'
            style={style}
        >
            <div className='color-picker-icon' 
                onClick={(e) => openPoup(e)}
                style={_iconStyle}
                >
                {children}
            </div>
            { open && (
                <div className='color-picker-lists' ref={refColorPicker}>
                    <div className='color-picker-items'>
                    {
                        colors.map((item, index) => (
                            <div key={`color-picker-${index}`}
                                className={`color-picker-item ${item == color ? ' active ' : ''}` }
                                onClick={() => onColorPicker(item)}
                            >
                                <div style={{...colorStyle, backgroundColor: item}}></div>
                            </div>
                        ))
                    }
                    </div>
                    <div className="color-picker-text">
                        <div className="color-picker-text-label">
                            Or enter a color
                        </div>
                        <div className="color-picker-text-field">
                            <TextField
                                inputProps={{
                                    value: text,
                                    name: 'orhexvalue',
                                    placeholder: "# hex value",
                                    onKeyDown: (e) => onEnterValue(e),
                                    ...inputProps}}
                                onChangeText={onEnterValue}
                            />
                        </div>
                    </div>
                </div>
            )
            }
        </div>
    )
}

export default ColorPicker;